module.exports = __webpack_public_path__ + "img/prop2.be6be800.png";